var moment = require("moment")
var axios = require('axios')
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"

const state = {
  uuid: null,
  agree: false,
  Numbers3: [],
  Numbers4: [],
  Loto6: [],
  Loto7: [],
  Numbers3WinningNumber: [],
  Numbers4WinningNumber: [],
  Loto6WinningNumber: [],
  Loto7WinningNumber: [],
}
const getters = {
  getNumbers3: state => state.Numbers3,
  getNumbers4: state => state.Numbers4,
  getLoto6: state => state.Loto6,
  getLoto7: state => state.Loto7,
  getNumbers3WinningNumber: state => state.Numbers3WinningNumber,
  getNumbers4WinningNumber: state => state.Numbers4WinningNumber,
  getLoto6WinningNumber: state => state.Loto6WinningNumber,
  getLoto7WinningNumber: state => state.Loto7WinningNumber,
}
const mutations = {
  setAgree: (state) => {
    state.agree = true
  },
  setLoto6(state, selectedNumbers){
    state.Loto6.push(
      {
        date: moment().format("YYYY年MM月DD日 HH時mm分ss秒"),
        numbers: selectedNumbers
      }
    )
  },
  setLoto7(state, selectedNumbers){
    state.Loto7.push(
      {
        date: moment().format("YYYY年MM月DD日 HH時mm分ss秒"),
        numbers: selectedNumbers
      }
    )
  },
  setNumbers3(state, selectedNumbers){
    state.Numbers3.push(
      {
        date: moment().format("YYYY年MM月DD日 HH時mm分ss秒"),
        numbers: selectedNumbers
      }
    )
  },
  setNumbers4(state, selectedNumbers){
    state.Numbers4.push(
      {
        date: moment().format("YYYY年MM月DD日 HH時mm分ss秒"),
        numbers: selectedNumbers
      }
    )
  }
}
const actions = {
  setAgree(context){ context.commit('setAgree') },
  setLoto6(context, selectedNumbers){ context.commit('setLoto6', selectedNumbers)},
  setLoto7(context, selectedNumbers){ context.commit('setLoto7', selectedNumbers)},
  setNumbers3(context, selectedNumbers){ context.commit('setNumbers3', selectedNumbers)},
  setNumbers4(context, selectedNumbers){ context.commit('setNumbers4', selectedNumbers)},
  setWinningNumber({state}){

    let getApi = (path, params, headers) => {
      if (!params) {
          params = {};
      }
      if (!headers) {
          headers = {};
      }
      return axios({
          method: "GET",
          url: path,
          params: params,
          headers: headers
      });
    };
  
    getApi('https://forgetmen.online/result.json')
    .then(response => {
      state.Numbers3WinningNumber = response.data.numbers3
      state.Numbers4WinningNumber = response.data.numbers4
      state.Loto6WinningNumber = response.data.loto6
      state.Loto7WinningNumber = response.data.loto7
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 
